import { Box, Typography, useTheme } from "@mui/material";

export default function TabPanel({ children, list, value, index, ...other }) {
    const theme = useTheme();

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            dir={theme.direction}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}
